module.exports = __webpack_public_path__ + "img/minus_btn.b0ddb647.png";